/*global $*/
/*eslint no-undef: "error"*/
export default class ContactTabs {
    classItem = 'contact-tabs--item'
    classTab = 'contact-tabs--tab'
    classTabActive = 'contact-map-tab---active'
    classBlock = 'contact-tabs--block'
    classBlockActive = 'contact-map-tabs__block---active'

    constructor () {
        let self = this

        $(`.${self.classTab}`).click(function () {
            let tab = $(this).data(`tab`)

            $(this).closest(`.${self.classItem}`).find(`.${self.classTab}`).removeClass(self.classTabActive)
            $(this).addClass(self.classTabActive)

            $(this).closest(`.${self.classItem}`).find(`.${self.classBlock}`).removeClass(self.classBlockActive)
            $(this).closest(`.${self.classItem}`).find(`.${self.classBlock}[data-block='${tab}']`).addClass(self.classBlockActive)
            console.log(tab)
        })
    }
}
